import styled from 'styled-components';

export const ScenarioHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 0 16px;
`;

export const BreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
`;

export const TpocLabel = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;

  &::after {
    content: '|';
    color: #999;
    font-weight: 400;
  }
`;

export const HeaderWrapper = styled.div`
  margin: 8px 16px 12px 40px;
`;
